var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn icon-btn btn-sm rotating",class:_vm.adding ? 'btn-secondary' : 'btn-success',attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('update:adding', !_vm.adding)}}},[_c('i',{staticClass:"ion ion-md-add",class:{ rotated: _vm.adding }})])
}
var staticRenderFns = []

export { render, staticRenderFns }